module.exports = __webpack_public_path__ + "static/images/peek-item.33WgV-R.svg";